import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isConnected: false,
  status: 'disconnected', // 'connecting', 'connected', 'disconnected', 'reconnecting'
  lastMessage: null,
  error: null,
  sessionId: null,
  messageHistory: [], // Optional: keep a short history of raw messages if needed
};

const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    connectionConnecting: (state) => {
      state.status = 'connecting';
      state.error = null;
    },
    connectionEstablished: (state) => {
      state.isConnected = true;
      state.status = 'connected';
      state.error = null;
    },
    connectionLost: (state) => {
      state.isConnected = false;
      state.status = 'disconnected';
    },
    connectionReconnecting: (state) => {
      state.isConnected = false;
      state.status = 'reconnecting';
    },
    connectionError: (state, action) => {
      state.error = action.payload;
    },
    messageReceived: (state, action) => {
      state.lastMessage = action.payload;
      // Limit history to last 50 messages
      if (state.messageHistory.length >= 50) {
        state.messageHistory.shift();
      }
      state.messageHistory.push({
        timestamp: new Date().toISOString(),
        data: action.payload,
      });
    },
    setSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
    clearMessageHistory: (state) => {
      state.messageHistory = [];
      state.lastMessage = null;
    },
  },
});

export const {
  connectionConnecting,
  connectionEstablished,
  connectionLost,
  connectionReconnecting,
  connectionError,
  messageReceived,
  setSessionId,
  clearMessageHistory,
} = websocketSlice.actions;

export default websocketSlice.reducer;
